<template>
<!--Main contents-->
<div class="box_center" id="page_x">
  <h2 class="shadow">Forgot Password</h2>
  <div id="feedback" v-if="errors.any() || error">
    <p class="error wrong_email error-box" v-if="errors.has('email')">Please enter a valid email</p>
    <p class="error wrong_message error-box" v-if="error">{{error}}</p>
  </div>
  <div class="input">
    <form name="formregister" v-if="!sent" @submit.prevent="sendForgot">
      <p class="text_form">
        Enter Email: <br />
      </p>
      <input type="text" name="email" maxlength="100" v-model="email" v-validate="'required|email'" data-vv-delay="2000" class="contact_form"/>
      <input type="submit" value="Reset Password" name="submitButton" class="button submit" />
    </form>
    <div v-if="sent">
      <p>Password reset successfully. </p>
      <p>Please check your email for your new password. The password can be changed in the my account section after logging in with your new password. <a href="/login">Log in.</a></p>
    </div>
  </div>
</div>
</template>
<script>
import AuthRepository from '../data/auth.repository.js'
import Nav from '../components/Nav'
import _ from 'lodash'
export default {
  components: {
    'navigation': Nav
  },
  data () {
    return {
      sent: false,
      email: '',
      error: ''
    }
  },
  methods: {
    sendForgot () {
      this.$validator.validateAll().then(() => {
        AuthRepository.resetPassword(this.email).then(user => {
          this.sent = true
          this.error = ''
        }).catch(e => {
          if (e.response && e.response.data) {
            let str = ''
            _.forOwn(e.response.data, (value, key) => {
              str += value.join(', ')
            })
            this.error = str
          }
        }).catch(() => {
          this.error = 'An error has occurred'
        })
      })
    }
  },
  metaInfo: {
    title: 'Forgot Password'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?c76272c4